var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEloBgblack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 29,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#111014",
    fillRule: "evenodd",
    d: "M3.53 0h45.92a3.53 3.53 0 013.53 3.53V25.9a3.53 3.53 0 01-3.53 3.53H3.53A3.53 3.53 0 010 25.9V3.53A3.53 3.53 0 013.53 0z",
    className: "elo-bgblack_svg__cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcb05",
    d: "M13.9 11.21a4.26 4.26 0 011.3-.2 4.06 4.06 0 014 3.17l2.8-.56a6.9 6.9 0 00-6.81-5.38 7.05 7.05 0 00-2.21.35l.92 2.62z",
    className: "elo-bgblack_svg__cls-18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a4e0",
    d: "M10.59 20l1.9-2.07a3.88 3.88 0 010-5.93l-1.9-2.07a6.59 6.59 0 000 10.07",
    className: "elo-bgblack_svg__cls-19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef4123",
    d: "M19.21 15.76a4.06 4.06 0 01-4 3.16 4 4 0 01-1.3-.21l-.92 2.65a7.05 7.05 0 002.21.35 6.9 6.9 0 006.81-5.35l-2.8-.6z",
    className: "elo-bgblack_svg__cls-20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.38 18.13a4.25 4.25 0 01-.37-3.61 4 4 0 012.17-2.37 4.18 4.18 0 013.85.28 4.08 4.08 0 011.72 2.07c.05.12.09.25.14.36l-7.51 3.27zm2.51-4.36a2.06 2.06 0 00-1.25 2.2l3.74-1.61a2 2 0 00-2.53-.59h.04zm3 3.53l-.08-.06a2.22 2.22 0 01-1 .86 2 2 0 01-2.19-.22l-.05.07-1 1.44a4.28 4.28 0 00.76.41 4.15 4.15 0 005-1.53l-1.44-.97zM34.58 10.22v7.81l1.34.49-.76 1.61-1.48-.56a1.68 1.68 0 01-.73-.55 1.6 1.6 0 01-.29-1v-7.8h1.92z",
    className: "elo-bgblack_svg__cls-21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.9 15.97a2.19 2.19 0 01.81-1.7l-1.33-1.41a4 4 0 000 6.21l1.31-1.41a2.21 2.21 0 01-.79-1.69zM40.24 18.22a2.25 2.25 0 01-.74-.12l-.63 1.8a4.41 4.41 0 001.37.21 4.26 4.26 0 004.22-3.31l-1.93-.38a2.32 2.32 0 01-2.29 1.8zM40.24 11.82a4.4 4.4 0 00-1.36.21l.62 1.8a2.35 2.35 0 013 1.69l1.93-.38a4.26 4.26 0 00-4.19-3.32z",
    className: "elo-bgblack_svg__cls-21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEloBgblack);
export default __webpack_public_path__ + "static/media/elo-bgblack.55f9dfe954a6af16507776c0317db892.svg";
export { ForwardRef as ReactComponent };